import { ORDER_TYPES } from '@exodus/fiat-client'

const resultFunction = (getIsAssetIntersectionSelector) =>
  getIsAssetIntersectionSelector(ORDER_TYPES.buy)

const isAssetBuyIntersectionSelectorDefinition = {
  id: 'isAssetBuyIntersection',
  resultFunction,
  dependencies: [{ selector: 'getIsAssetIntersectionByOrderType' }],
}

export default isAssetBuyIntersectionSelectorDefinition
